import React from "react";
import Modal from "react-modal";
import Fascia_form from "../screens/exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import AddExhibitorBadge from "../screens/exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge_add";
import Exhibitor_details from "../screens/exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import InvitationVisaApplicationAU from "../screens/exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationAU";
import Water from "../screens/exhibitor_module/manual_forms/forms/water_form/water";
import Power from "../screens/exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import Air from "../screens/exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import Edirectory from "../screens/exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_add_form";
import StallDesign from "../screens/exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import BrandingOpportunity from "../screens/exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";

// At the top of your component file
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "1200px",
    height: "90vh",
    overflowY: "auto",
    padding: 0,
    borderRadius: "10px",
    border: "none",
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 9999,
  },
};

class CommonModal extends React.Component {
  renderComponent = () => {
    const { componentName, componentProps, location } = this.props;

    console.log("CommonModal props", this.props)
    const formIdKeyMap = {
      "Exhibitor Paid Badges": "exhibitorBadgeFormId",
      "Visa Application": "VisaApplicationFormID",
      "EdirectoryAdd": "eDirectoryID",
    };

    const formIdKey = formIdKeyMap[componentName] || "FormID";

    const derivedLocation = {
      ...location,
      state: {
        ...(location?.state || {}),
        [formIdKey]: componentProps.FormID,
        is_View: componentProps.is_View,
        UnPaid: componentProps.UnPaid,
      },
    };

    const componentsMap = {
      Fascia: <Fascia_form location={derivedLocation} />,
      "Exhibitor Paid Badges": <AddExhibitorBadge location={derivedLocation} />,
      exhibitorDetails: <Exhibitor_details location={derivedLocation} />,
      "Visa Application": <InvitationVisaApplicationAU location={derivedLocation} />,
      Power: <Power location={derivedLocation} />,
      Water: <Water location={derivedLocation} />,
      Air: <Air location={derivedLocation} />,
      EdirectoryAdd: <Edirectory location={derivedLocation} />,
      "Stall design": <StallDesign location={derivedLocation} />,
      "Branding Opportunity": <BrandingOpportunity location={derivedLocation} />,
    };

    return componentsMap[componentName] || null;
  };

  render() {
    const { isOpen, onClose } = this.props;
    console.log("rrrrrrrr", this.props);
    return (
      // common-modal-portal: the forms shown here are full pages with their own header,
      // sidebar and tab bar (fixed to the screen, so they covered this dialog);
      // responsive-fixes.css hides that page frame inside the portal and makes the
      // dialog near full screen
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
        portalClassName="common-modal-portal"
      >
        <div className="modal-dialog modal-almost-fullscreen">
          <div className="modal-content">
            <div className="modal-header text-white">
              <h6 className="modal-title">Manual Form</h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} />
            </div>

            {/* <div className="modal-body">{this.openModal(this.state.selectedServiceName)}</div> */}
            <div className="modal-body p-2">{this.renderComponent()}</div>
            {/* <div className="modal-body">{<BrandingOpportunity />}</div> */}
            <div className="modal-footer">
              <button className="btn btn-gray" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default CommonModal;
